/**
 * Created by Mark on 24/04/2017.
 */


import React from "react";
import { FormattedMessage } from 'react-intl';
import LineGraph from '../../graphs/WordsLearntGraph.js';
import WordsLearntService from '../../../services/wordslearnt-services.js';
import WordsLearntStore   from '../../../store/words-learnt-store.js';
import HomeworkWidget from '../../homework.js';
import DateHelper from '../../../classes/date.js';
import {Col , Row} from 'react-bootstrap';
import DataInput from '../../inputs/date.input.js'
import SkillsBar from '../../graphs/skillsGraph.js';
import ScoresService from '../../../services/scores-services.js';
import ScoresStore from '../../../store/scores-store.js';
import Select from  'react-select';
import DateInput from '../../inputs/date.input.js';
import InternationalizationStore from '../../../store/internationalization-store.js';
import ReadingBar from '../../graphs/readingGraph.js';
import StudentService from '../../../services/student-services.js';
import StudentStore from '../../../store/student-store.js';
import domtoimage from "dom-to-image";
import moment from 'moment';
import jsPDF from 'jspdf';
import MedalGraphic from '../../media/medal.image.js';
import MedalServices from '../../../services/medals-service.js';
import MedalStore from '../../../store/medals-store.js';

class AboutPanel extends React.Component {

    constructor(props){
        super();

        moment.locale(InternationalizationStore.determineLocaleFromBrowser());

        var d =   new Date();
        var due = new Date(); due.setMonth(due.getMonth() - 6);

        let to  =  d.getUnixTime();
        let from  = due.getUnixTime();

        this.props = props;
        this.state ={
            wordsLearnt:[],
            to:to,
            from:from,
            languageValue:{ value: "all", label: "ALL"},
        };

        this.handelSetFromDateSelect = this.handelSetFromDateSelect.bind(this);
        this.handelSetToDateSelect = this.handelSetToDateSelect.bind(this);
    }


    getData(from , to , language){
        StudentService.getStudent(this.props.data.studentID);
        StudentService.getStudentLanguages(this.props.data.studentID);
        WordsLearntService.getLineGraphStudentLevel(this.props.data.studentID , from , to , language);
        WordsLearntService.getStudentTotal(this.props.data.studentID , from , to , language);
        MedalServices.getStudentMedals(this.props.data.studentID , from , to , language);

    }

    componentDidMount() {
       this.getData(this.state.from , this.state.to , this.state.languageValue.value);
    }

    componentWillMount(){
        WordsLearntStore.on("UPDATE_STUDENT_TOTAL" , () => {
            this.setState({wordsLearnt:WordsLearntStore.studentLevelCommunicative , wordsLearntNone:WordsLearntStore.studentLevelNoneCommunicative});
        });

        WordsLearntStore.on("UPDATE_STUDENT_WORDS_TOTAL" , () => {
            this.setState({totalWords:WordsLearntStore.studentTotal});
        });

        ScoresStore.on("CHANGE" , () => {
            this.setState({"totalSkills":ScoresStore.studentLevel})
        });

        StudentStore.on('STUDENT_UPDATE' , () => {
            this.setState({student:StudentStore.student});
        });

        StudentStore.on('STUDENT_LANGUAGE_UPDATE' , () => {
            this.setState({languages:StudentStore.studentlanguages});
        });

        MedalStore.on("UPDATE_STUDENT_MEDALS_TOTAL" , () => {
            this.setState({
                gold:MedalStore.getStudentGold(),
                silver:MedalStore.getStudentSilver(),
                bronze:MedalStore.getStudentBronze(),
            });
        });
    }


    downloadProgressCertificate(){

        function getDataUri(url) {
            var image = new Image();

            return new Promise(function(resove){

                image.onload = function () {
                    var canvas = document.createElement('canvas');
                    canvas.width = this.naturalWidth; // or 'width' if you want a special/scaled size
                    canvas.height = this.naturalHeight; // or 'height' if you want a special/scaled size

                    canvas.getContext('2d').drawImage(this, 0, 0);

                    // Get raw image data
                    //callback(canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, ''));

                    // ... or get as Data URI
                    resove(canvas.toDataURL('image/png'));
                };

                image.src = url;

            });


        }

        var centeredText = function(text, y , doc) {
            var textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
            doc.text(textOffset, y, text);
        };

        var OffsetText  = function(text, x ,  y , doc){
            var textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffset = x - textWidth/2;
            doc.text(textOffset, y, text);
        };

        return Promise.all([getDataUri('img/progress-cert-background.png') , StudentService.getProgressReportData(this.props.data.studentID , this.state.from , this.state.to , this.state.languageValue.value)]).then(function(response){

            console.log(response[1]);


            var studentName = "Mark Smith";
            var Language = "French";
            var Range = "00-00-00 to 00-00-00";
            var TotalWords = 999999;

            var AveragePoints = "999"
            var pdf = new jsPDF('landscape');

            for(var idx = 0 ; idx < response[1].reports.length; idx++)
            {
                var report = response[1].reports[idx];

                if(idx > 0 ) pdf.addPage();

                var studentName = report.name;
                var Language = InternationalizationStore.getTranslation('ui-'+report.language_title , 'notfound')
                var Range = report.from_date + " "+InternationalizationStore.getTranslation('ui-699' , 'notfound')+" " + report.to_date;
                var TotalWords = report.words_learnt;

                var AveragePoints = report.average_points;

                pdf.addImage(response[0], 'JPEG', 0, 0, 297 ,210);
                pdf.setTextColor(33, 20, 60)

                pdf.setFontSize(12);
                centeredText(String(Language), 55 , pdf);
                centeredText(String(Range).toLowerCase(), 50 , pdf);

                pdf.setFontType("bold");

                pdf.setFontSize(25);
                pdf.setFontSize(50);
                centeredText(String(studentName).toUpperCase(), 92 , pdf);

                pdf.setFontSize(35);
                centeredText(String(InternationalizationStore.getTranslation('ui-696' , 'notfound')).toUpperCase() , 70 , pdf);

                OffsetText(String(report.gold), 80 ,  155 , pdf)
                OffsetText(String(report.silver), 146 ,  155 , pdf)
                OffsetText(String(report.bronze), 215 ,  155 , pdf)

                pdf.setFontSize(26);
                centeredText(this.state.student.getName() , 40 , pdf);


                pdf.setFontSize(12);
                pdf.text(28, 188, InternationalizationStore.getTranslation('ui-97' , 'notfound') + " : " + String(TotalWords));


                pdf.setFontSize(12);
                pdf.text(180, 188, InternationalizationStore.getTranslation('ui-815' , 'notfound') + " : " + String(AveragePoints));

            }


            pdf.save(this.state.student.getName() + "-" + InternationalizationStore.getTranslation('ui-696' , 'notfound')+'.pdf');

            //97

        }.bind(this));

    }

    convertValueToISOString(value) {

        return Number(value) > 0 ? (new Date(Number(value) * 1000)).toISOString() : value
    }

    downloadReport(){


        function getDataUri(url) {
            var image = new Image();

            return new Promise(function(resove){

                image.onload = function () {
                    var canvas = document.createElement('canvas');
                    canvas.width = this.naturalWidth; // or 'width' if you want a special/scaled size
                    canvas.height = this.naturalHeight; // or 'height' if you want a special/scaled size

                    canvas.getContext('2d').drawImage(this, 0, 0);

                    // Get raw image data
                    //callback(canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, ''));

                    // ... or get as Data URI
                    resove(canvas.toDataURL('image/png'));
                };

                image.src = url;

            });


        }

        let self = this;
        return Promise.all([
            domtoimage.toPng(document.getElementById('progressSkills')) ,
            domtoimage.toPng(document.getElementById('readingGraph')) ,
            domtoimage.toPng(document.getElementById('listeningGraph')) ,
            domtoimage.toPng(document.getElementById('writingGraph')),
            domtoimage.toPng(document.getElementById('speakingGraph')) ,
            getDataUri("img/graph.png"),
            getDataUri("img/medals/50-gold.png"),
            getDataUri("img/medals/50-silver.png"),
            getDataUri("img/medals/50-bronze.png"),
            getDataUri("img/logos/languagenut/no-text-logo.png")
        ]).then(function(images){



            var pdf = new jsPDF();

            pdf.setTextColor(33, 20, 60)

            pdf.setDrawColor(0)
            pdf.setFillColor(131, 207, 203);
            pdf.rect(0 , 0, 15, 500 , 'F');

            pdf.setDrawColor(131, 207, 203)
            pdf.setFillColor(255, 255, 255)
            pdf.setLineWidth(2);
            pdf.circle(17, 278, 15, 'FD')

            pdf.setTextColor(255, 255, 255)
            pdf.setFontSize(20);
            //pdf.text(10, 250 , 'hello world', 90);

            pdf.setTextColor(0)
            pdf.setFontSize(20);
            pdf.text(20, 20, this.state.student.getName() + ' - '+ InternationalizationStore.getTranslation('ui-684' , 'notfound'));


            pdf.setFontSize(13);
            pdf.text(20, 30,    InternationalizationStore.getTranslation('ui-492' , 'notfound'));
            pdf.text(45*2, 30, InternationalizationStore.getTranslation('ui-698' , 'notfound'));
            pdf.text(45*3, 30, InternationalizationStore.getTranslation('ui-699' , 'notfound'));
            pdf.text(20, 35,  String(self.state.languageValue.label));
            pdf.text(45*2, 35,  String(moment(self.convertValueToISOString(self.state.from)).format('L')));
            pdf.text(45*3, 35,  String(moment(self.convertValueToISOString(self.state.to)).format('L')));



            pdf.setFontSize(20);
            pdf.text(22, 60, String(this.state.totalWords));
            pdf.text(22+ 45, 60, String(this.state.gold));
            pdf.text(22+ 45*2, 60, String(this.state.silver));
            pdf.text(22+ 45*3, 60, String(this.state.bronze));

            pdf.setFontSize(10);

            pdf.setTextColor(7, 180, 210)
            pdf.text(22, 65, InternationalizationStore.getTranslation('ui-97' , 'notfound'));
            pdf.text(22+ 45, 65, InternationalizationStore.getTranslation('ui-271' , 'notfound'));
            pdf.text(22+ 45*2, 65, InternationalizationStore.getTranslation('ui-270' , 'notfound'));
            pdf.text(22+ 45*3, 65, InternationalizationStore.getTranslation('ui-269' , 'notfound'));

            pdf.setTextColor(33, 20, 60)
            console.log(this.state.student.getName());
            pdf.addImage(images[5], 'JPEG', 45, 56, 12 ,8);
            pdf.addImage(images[6], 'JPEG', 45+ 45, 54 , 12 ,12);
            pdf.addImage(images[7], 'JPEG', 45+ 45*2, 54, 12, 12);
            pdf.addImage(images[8], 'JPEG', 45+ 45*3, 54, 12, 12);
            //pdf.text(20, 50, 'Language');


            pdf.addImage(images[9], 'JPEG', 0, 265,  33, 30);

            pdf.addImage(images[0], 'JPEG', 20, 75, 175, 59);

            pdf.setDrawColor(224, 224, 224);
            pdf.setLineWidth(0.3);
            for(var idx = 0; idx < 4; idx++)
            {
                pdf.rect(20 + (idx*45), 50, 40, 20);
            }

            pdf.rect(20 , 75, 175, 60);
            console.log(this.state.student.getName());
            var text = [InternationalizationStore.getTranslation('ui-119' , 'notfound') , InternationalizationStore.getTranslation('ui-117' , 'notfound') , InternationalizationStore.getTranslation('ui-120' , 'notfound') , InternationalizationStore.getTranslation('ui-118' , 'notfound')]
            for(var idx = 0; idx < 4; idx++) {
                if (idx == 0)
                {
                    pdf.setFillColor(251, 166, 138);
                    pdf.setDrawColor(251, 166, 138);
                }


                if (idx == 1) {
                    pdf.setFillColor(254, 210, 167);
                    pdf.setDrawColor(254, 210, 167);
                }

                if(idx == 2)
                {
                    pdf.setFillColor(202, 228, 247);
                    pdf.setDrawColor(202, 228, 247);
                }

                if(idx == 3)
                {
                    pdf.setFillColor(248, 187, 217);
                    pdf.setDrawColor(248, 187, 217);
                }


                pdf.rect(20 + (idx*45), 142, 40, 40 , 'FD');

                pdf.text(20 + (idx*45), 140, text[idx]);

                pdf.addImage(images[idx + 1], 'JPEG', 20 + (idx*45), 142, 40, 40);
            }
            console.log(this.state.student.getName());
            pdf.save(this.state.student.getName() + "-" + InternationalizationStore.getTranslation('ui-684' , 'notfound')+'.pdf');
        }.bind(this));
    }


    renderBadge(id , icon , text , number){
        return <div className="ca-item media b-1">
            <div id={id} className="pull-right hidden-md hidden-xs hidden-sm">
                {icon}
            </div>
            <div className="media-body palette-Branding primary text">
                <h2 className="palette-Branding primary text">{text}</h2>
                <small className="palette-Branding secondary text">
                    {number}
                </small>
            </div>
        </div>
    }

    renderHeader(){

        return  [
            <Col sm={3} >{this.renderBadge("words", <img className="p-t-10" style={{
            maxWidth:25,
        }} src="img/graph.png"/> , this.state.totalWords || 0 ,  <FormattedMessage id={ 'ui-813' } defaultMessage={ 'Words Learnt' }/>)}</Col>,
            <Col sm={3}>{this.renderBadge("gold", <MedalGraphic size={25} medal="gold"/> , this.state.gold ,  <FormattedMessage id={ 'ui-271' } defaultMessage={ 'Total Gold' }/>)}</Col>,
            <Col sm={3}>{this.renderBadge("silver", <MedalGraphic size={25} medal="silver"/> , this.state.silver ,  <FormattedMessage id={ 'ui-270' } defaultMessage={ 'Total Silver' }/>)}</Col>,
            <Col sm={3}>{this.renderBadge("bronze", <MedalGraphic size={25} medal="bronze"/> , this.state.bronze ,  <FormattedMessage id={ 'ui-269' } defaultMessage={ 'Total Bronze' }/>)}</Col>
        ]
    }

    onLanguageSelect(object){


        this.setState({
            languageValue:object
        });

        this.getData(this.state.from , this.state.to , object.value);
    }

    handelSetFromDateSelect(val){

        console.log(val);
        let from = (new Date(val)).getUnixTime();
        this.setState({from:from});
        this.getData(from , this.state.to , this.state.languageValue.value);
    }

    handelSetToDateSelect(value){
        let to = (new Date(value)).getUnixTime();
        this.setState({to:to});
        this.getData(this.state.from , to , this.state.languageValue.value);
    }

    downloadCSV(){

    }

    render(){

        if(!this.state.student || !this.state.languages) return null;


        let download = <button  onClick={this.downloadReport.bind(this)} className="btn  m-r-10 btn-primary b-btn-icon-text waves-effect pull-right"><i className="palette-White text zmdi zmdi-download"></i>  <FormattedMessage id={ String("ui-474")} defaultMessage={ "Download Report" } /></button>
        let downloadCert = <button  onClick={this.downloadProgressCertificate.bind(this)} className="btn    m-t-0 btn-primary b-btn-icon-text waves-effect pull-right"><i className="palette-White text zmdi zmdi-download"></i>  <FormattedMessage id={ String("ui-696")} defaultMessage={ "Download Report" } /></button>
        const options = this.state.languages.map(function(language){
            return  { value: language.ietf, label: language.getName()}
        });
        if (options.length > 1) {
            options.push({ value: "all", label: "ALL"});
        } else if (options.length == 1) {
            this.state.languageValue = options[0];
        }

        let Reports = <Row className="p-b-10">
            <Col className="" sm={12}>
                {downloadCert}
                {download}
            </Col>
        </Row>

        if(sessionStorage.getItem("product") == "pratstart")
        {
            Reports = null;
        }


        return <div id="progressReport" className="pmb-block">
            <div className="pmb-block p-0">
                <div className="pmbb-header">
                    <Row className="row" >
                        <Col  sm={8}>
                            <h2>{this.state.student.getName()} <FormattedMessage id={ 'ui-684' } defaultMessage={ 'Progress Report' } /></h2>
                        </Col>
                    </Row>
                    <Row className="p-t-10">
                        <Col sm={6}>
                            <div className="form-group fg-line">
                                <label className="fg-label control-label">
                                    <FormattedMessage id={"ui-492"} defaultMessage={"Select Language"}/>
                                </label>
                                <Select multi={false} disabled={this.state.languages.length <= 1} onChange={this.onLanguageSelect.bind(this)}
                                        value={this.state.languageValue} options={options} noResultsText={<FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found" }/>}
                                        placeholder={<FormattedMessage id={ 'ui-892' } defaultMessage={ 'Select' }/>}/>
                            </div>
                        </Col>
                        <Col  sm={3}>
                            <DateInput onSelect={this.handelSetFromDateSelect} value={this.state.from} labelTranslationUID={"ui-698"}/>
                        </Col>
                        <Col  sm={3}>
                            <DateInput onSelect={this.handelSetToDateSelect} value={this.state.to} labelTranslationUID={"ui-699"}/>
                        </Col>
                    </Row>
                    {Reports}
                </div>
                <div className="pmbb-body">
                    <Row id="Medal-Header">
                        {this.renderHeader()}
                    </Row>
                    <Row className="p-t-10">
                        <div className="col-md-12">
                            <div className="b-1">
                                <LineGraph  dataKeys={[{key:'words' , fill:'#32C388'} , {key:'total_reading' , fill:'#fd470a'}  , {key:'total_listening' , fill:'#ff8417'} , {key:'total_speaking' , fill:'#1b9ff6'} , {key:'total_writing' , fill:'#fa74b7'}]} data={this.state.wordsLearnt} height={200} id="progressSkills"/>
                            </div>
                        </div>
                    </Row>

                    <Row className="">
                        <div className="col-md-3 col-xs-6">
                            <FormattedMessage id={ String("ui-119")} defaultMessage={ "Reading" } />
                            <div className="b-1 bkg-reading">
                                <ReadingBar name={InternationalizationStore.getTranslation('ui-119' , 'notfound')}
                                            fill='#fd470a' dataKeys={[{key:'reading'}]}  data={this.state.wordsLearntNone} height={203} id="readingGraph" />
                            </div>
                        </div>
                        <div className="col-md-3 col-xs-6">
                            <FormattedMessage id={ String("ui-117")} defaultMessage={ "Download Report" } />
                            <div className="b-1 bkg-listening">
                                <ReadingBar name={InternationalizationStore.getTranslation('ui-117' , 'notfound')} fill='#ff8417' dataKeys={[{key:'listening'}]}  data={this.state.wordsLearntNone} height={203} id="listeningGraph" />
                            </div>
                        </div>
                        <div className="col-md-3 col-xs-6">
                            <FormattedMessage id={ String("ui-120")} defaultMessage={ "Download Report" } />

                            <div className="b-1 bkg-writing">
                                <ReadingBar name={InternationalizationStore.getTranslation('ui-120' , 'notfound')} fill='#fa74b7' dataKeys={[{key:'writing'}]}  data={this.state.wordsLearntNone} height={203} id="writingGraph" />
                            </div>
                        </div>
                        <div className="col-md-3 col-xs-6">
                            <FormattedMessage id={ String("ui-118")} defaultMessage={ "Download Report" } />

                            <div className="b-1 bkg-speaking">
                                <ReadingBar name={InternationalizationStore.getTranslation('ui-118' , 'notfound')} fill='#1b9ff6' dataKeys={[{key:'speaking'}]}  data={this.state.wordsLearntNone} height={203} id="speakingGraph" />
                            </div>
                        </div>
                    </Row>
                </div>
            </div>
        </div>;

        return (
            <div>
                <div className="pmb-block">
                    <div className="pmbb-header">
                        <div className="row">
                            <Col  sm={8}>
                                <h2><FormattedMessage id={ 'ui-684' } defaultMessage={ 'Progress Report' } /></h2>
                                <small><FormattedMessage id={ 'ui-97' } defaultMessage={ 'Words Learnt' } /></small>
                            </Col>
                            <Col  sm={4}>
                                <h2></h2>
                                <small><FormattedMessage id={ 'ui-909' } defaultMessage={ '' } /></small>
                            </Col>
                        </div>
                    </div>
                    <div className="pmbb-body">
                        <div className="row">
                            <div className="col-md-8">
                                <LineGraph dataKeys={[{key:'words' , fill:'#32C388'}]} data={this.state.wordsLearnt} height={200} id="progressSkills"/>
                            </div>
                            <div className="col-md-4">
                                <SkillsBar dataKeys={[{key:'score'}]} data={this.state.totalSkills} height={203} id="averageScores"/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}





export default {
    name: <FormattedMessage id={ 'ui-684' } defaultMessage={ 'Dashboard' }/>,
    component: AboutPanel
}


// WEBPACK FOOTER //
// ./src/components/profile/profile-tabs/about-student-panel.js